import React from 'react';
import { Outlet } from 'react-router-dom';

const ManageActivities = () => {
  return <Outlet />;
};

export default ManageActivities;
